const CodiciErroreInvio = {
  ERR_RETE: 10,
  ERR_AGGIUNGI: 20,
  ERR_AGGIORNA: 30,
  ERR_ELIMINA: 40,
  ERR_INVIA: 50,
};

export default CodiciErroreInvio;
